/* eslint-disable no-unused-vars */
import axios from 'axios';
import api from '@src/api';
import _ from 'lodash';
import store from '@state/store';

const appConfig = require('@src/app.config');

export const state = initialState();

// state is a function so it can be instantiated again - reset
function initialState() {
  return {
    orgDetails: {},
  };
}

export const getters = {
  sitename(state, getters) {
    console.log(state.orgDetails);
    return state.orgDetails.name;
  },
  storeUrls(state, getters) {
    return state.orgDetails.storeUrls;
  },
  backgroundImg(state, getters) {
    return state.orgDetails.webBackground;
  },
  primaryColor(state, getters) {
    let primaryDefault = '#4059e1';
    if(state.orgDetails && state.orgDetails.primary_color && state.orgDetails.primary_color !== undefined){
      primaryDefault = state.orgDetails.primary_color
    }
    return primaryDefault;
  },
  darkLogoUrl(state, getters) {
    let url = 'https://tandem-email.s3.amazonaws.com/smartfitness-logo-dark.png';
    if(state.orgDetails && state.orgDetails.mediaAssets && state.orgDetails.mediaAssets['logo-dark-png'].url && state.orgDetails.mediaAssets['logo-dark-png'].url !== undefined )
    {
      // eslint-disable-next-line no-undef
      url = state.orgDetails.mediaAssets['logo-dark-png'].url;
    }
    return url;
  },
  lightLogoUrl(state, getters) {
    let url = 'https://tandem-email.s3.amazonaws.com/smartfitness-logo.png';
    if(state.orgDetails && state.orgDetails.mediaAssets && state.orgDetails.mediaAssets['logo-light-png'].url && state.orgDetails.mediaAssets['logo-light-png'].url !== undefined )
    {
      // eslint-disable-next-line no-undef
      url = state.orgDetails.mediaAssets['logo-light-png'].url;
    }
    return url;
  },
};

export const mutations = {
  setOrgDetails(state, newValue) {
    state.orgDetails = newValue;
  },
  reset(state) {
    // acquire initial state
    const s = initialState();
    Object.keys(s).forEach((key) => {
      state[key] = s[key];
    });
  },
};

export const actions = {
  getOrgDetails({ state, commit }, orgId) {
    if (orgId && orgId.length === 24) {
      const url = api.URL_ORG_DETAILS.replace(':orgID', orgId);
      return axios
        .get(url)
        .then((response) => response.data)
        .then((response) => {
          const org = response.org;
          const streamAppId = response.org.stream.appId;
          commit('setOrgDetails', org);
          store.commit('auth/SET_STREAM_APP_ID', streamAppId);
          return org;
        })
        .catch((err) => {
          if (err.response) {
            console.error(err.response);
          } else {
            console.error(err);
          }

          return null;
        });
    } else {
      return null;
    }
  },
};
